import React from 'react'

import { getBlogImageSrc } from '../../../Blog/utils/getBlogImageSrc'
import { formatHomepagePostDate, getHomepageInFocusPosts } from '../../utils/homepagePosts'
import HomeLink from '../HomeLink/HomeLink'
import styles from './styles.module.scss'

type InFocusProps = {
  title: string
  ctaLabel: string
}

const InFocus = ({ title, ctaLabel }: InFocusProps) => {
  const posts = getHomepageInFocusPosts()

  if (!posts.length) return null

  return (
    <section className={styles.section} aria-labelledby="in-focus-title">
      <div className={styles.content}>
        <div className={styles.heading}>
          <h2 id="in-focus-title">{title}</h2>
        </div>
        <div className={styles.cards}>
          {posts.map((post) => {
            const { frontmatter } = post
            const image = getBlogImageSrc(frontmatter.image)

            return (
              <article key={post.slug} className={styles.card}>
                {image && <img src={image} alt={frontmatter.imageAlt || frontmatter.title || ''} />}
                <div className={styles.cardContent}>
                  <p className={styles.meta}>
                    {frontmatter.category || 'INSIGHTS'}
                    {frontmatter.readTime && ` · ${frontmatter.readTime}`}
                    {frontmatter.date && ` · ${formatHomepagePostDate(frontmatter.date)}`}
                  </p>
                  <h3>{frontmatter.title}</h3>
                  <HomeLink className={styles.readMore} to={`/blog/${post.slug}`}>
                    <span aria-hidden>→</span> {ctaLabel}
                  </HomeLink>
                </div>
              </article>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default InFocus
